// Vendor
import { createReducer, on } from '@ngrx/store';
// Actions
import { setCustomTexts } from './custom-texts.actions';
import { resetAllCustomPdfReportItems } from '../actions';
export const customTexts = createReducer({}, on(setCustomTexts, (state, action) => {
    return action.customTexts;
}), on(resetAllCustomPdfReportItems, () => {
    return {};
}));
